(function() {
  window.SubscriptionPriceUpdater = {
    updateTimer: null,
    isUpdatingVariant: false,
    
    debouncedUpdate: function(container, delay) {
      const self = this;
      delay = delay || 150;
      
      if (this.isUpdatingVariant) {
        return;
      }
      
      if (this.updateTimer) {
        clearTimeout(this.updateTimer);
      }
      
      this.updateTimer = setTimeout(function() {
        self.updatePerCupPrice(container);
      }, delay);
    },
    
    getCurrentVariantPrice: function(container) {
      const targetContainer = container || document;
      
      try {
        const appstleWidget = targetContainer.querySelector('.appstle_subscription_wrapper');
        if (appstleWidget) {
          const oneTimeRadio = appstleWidget.querySelector('input[name="selling_plan"][value=""]');
          if (oneTimeRadio) {
            const oneTimeWrapper = oneTimeRadio.closest('.appstle_subscription_wrapper_option');
            if (oneTimeWrapper) {
              const oneTimePrice = oneTimeWrapper.querySelector('.appstle_subscription_amount');
              if (oneTimePrice && oneTimePrice.textContent) {
                const priceText = oneTimePrice.textContent.trim();
                if (priceText) {
                  const priceMatch = priceText.match(/[\d,]+\.?\d*/);
                  if (priceMatch) {
                    const price = Math.round(parseFloat(priceMatch[0].replace(',', '')) * 100);
                    if (!isNaN(price) && price > 0) {
                      return { price: price, source: 'appstle' };
                    }
                  }
                }
              }
            }
          }
        }
      } catch (e) {
        // Silently handle Appstle widget errors
        console.log('Appstle price retrieval error:', e);
      }
      
      const priceContainer = targetContainer.querySelector('.price-container, #price-quickadd-template--product, [id^="price-"]');
      if (priceContainer) {
        const isInsideAppstle = priceContainer.closest('.appstle_subscription_wrapper');
        
        if (!isInsideAppstle) {
          const compareAtPrice = priceContainer.querySelector('.price-item--regular');
          if (compareAtPrice) {
            const priceText = compareAtPrice.textContent.trim();
            const priceMatch = priceText.match(/[\d,]+\.?\d*/);
            if (priceMatch) {
              const price = Math.round(parseFloat(priceMatch[0].replace(',', '')) * 100);
              return { price: price, source: 'regular' };
            }
          }
          
          const anyPriceItem = priceContainer.querySelector('.price-item');
          if (anyPriceItem) {
            const priceText = anyPriceItem.textContent.trim();
            const priceMatch = priceText.match(/[\d,]+\.?\d*/);
            if (priceMatch) {
              const price = Math.round(parseFloat(priceMatch[0].replace(',', '')) * 100);
              return { price: price, source: 'fallback' };
            }
          }
        }
      }
      
      const selectors = [
        '.price__regular .price-item--regular',
        '.price .price-item--regular',
        '.price-item--regular',
        '.price-item'
      ];
      
      for (const selector of selectors) {
        const element = targetContainer.querySelector(selector);
        if (element && !element.closest('.appstle_subscription_wrapper')) {
          const priceText = element.textContent.trim();
          const priceMatch = priceText.match(/[\d,]+\.?\d*/);
          if (priceMatch) {
            const price = Math.round(parseFloat(priceMatch[0].replace(',', '')) * 100);
            return { price: price, source: 'fallback' };
          }
        }
      }
      
      const variantInput = targetContainer.querySelector('input[name="id"]');
      if (variantInput && variantInput.value) {
        const variantId = variantInput.value;
        const scriptTags = targetContainer.querySelectorAll('script[type="application/json"]');
        for (const script of scriptTags) {
          try {
            const data = JSON.parse(script.textContent);
            if (data.variants) {
              const variant = data.variants.find(v => v.id == variantId);
              if (variant && variant.price) {
                return { price: variant.price, source: 'json' };
              }
            }
          } catch (e) {
            continue;
          }
        }
      }
      
      return null;
    },

    getSubscriptionDiscount: function(container) {
      const targetContainer = container || document;
      
      try {
        const subscriptionRadio = targetContainer.querySelector('input[name="selling_plan"]:checked');
        
        if (!subscriptionRadio || !subscriptionRadio.value || subscriptionRadio.value === '') {
          return 0;
        }
        
        const subscriptionWrapper = subscriptionRadio.closest('.appstle_subscription_wrapper_option');
        
        if (subscriptionWrapper) {
          const discountBadge = subscriptionWrapper.querySelector('.appstle-save-badge');
          
          if (discountBadge && discountBadge.textContent) {
            const badgeText = discountBadge.textContent.trim();
            if (badgeText) {
              const discountMatch = badgeText.match(/(\d+)%/);
              if (discountMatch) {
                const discount = parseFloat(discountMatch[1]);
                if (!isNaN(discount) && discount >= 0) {
                  return discount;
                }
              }
            }
          }
          
          const subscriptionPrice = subscriptionWrapper.querySelector('.appstle_subscription_amount');
          const comparePrice = subscriptionWrapper.querySelector('.appstle_subscription_compare_amount');
          
          if (subscriptionPrice && subscriptionPrice.textContent && 
              comparePrice && comparePrice.textContent) {
            const subPriceText = subscriptionPrice.textContent.trim();
            const comparePriceText = comparePrice.textContent.trim();
            
            if (subPriceText && comparePriceText) {
              const subPriceMatch = subPriceText.match(/[\d,]+\.?\d*/);
              const comparePriceMatch = comparePriceText.match(/[\d,]+\.?\d*/);
              
              if (subPriceMatch && comparePriceMatch) {
                const subPrice = parseFloat(subPriceMatch[0].replace(',', ''));
                const compPrice = parseFloat(comparePriceMatch[0].replace(',', ''));
                
                if (!isNaN(subPrice) && !isNaN(compPrice) && compPrice > 0) {
                  const discount = ((compPrice - subPrice) / compPrice) * 100;
                  return Math.round(discount);
                }
              }
            }
          }
        }
      } catch (e) {
        // Silently handle Appstle widget errors
        console.log('Appstle discount calculation error:', e);
      }
      
      return 0;
    },

    formatMoney: function(cents, container) {
      const targetContainer = container || document;
      
      try {
        const appstleWidget = targetContainer.querySelector('.appstle_subscription_wrapper');
        if (appstleWidget) {
          const oneTimePrice = appstleWidget.querySelector('.appstle_one_time_details_wrapper .appstle_subscription_amount');
          if (oneTimePrice && oneTimePrice.textContent) {
            const sampleText = oneTimePrice.textContent.trim();
            if (sampleText) {
              const numberMatch = sampleText.match(/[\d,]+\.?\d*/);
              if (numberMatch) {
                const numberPart = numberMatch[0];
                const beforeNumber = sampleText.substring(0, sampleText.indexOf(numberPart));
                const afterNumber = sampleText.substring(sampleText.indexOf(numberPart) + numberPart.length);
                
                const hasCommaDecimal = numberPart.includes(',') && !numberPart.includes('.');
                const decimalSeparator = hasCommaDecimal ? ',' : '.';
                const thousandSeparator = hasCommaDecimal ? '.' : ',';
                
                const dollars = Math.floor(cents / 100);
                const centsValue = cents % 100;
                
                let formattedNumber;
                if (centsValue === 0) {
                  formattedNumber = dollars.toString();
                } else {
                  const centsStr = centsValue.toString().padStart(2, '0');
                  formattedNumber = dollars + decimalSeparator + centsStr;
                }
                
                if (dollars >= 1000) {
                  const parts = formattedNumber.split(decimalSeparator);
                  parts[0] = parts[0].replace(/\B(?=(\d{3})+(?!\d))/g, thousandSeparator);
                  formattedNumber = parts.join(decimalSeparator);
                }
                
                if (formattedNumber.includes(decimalSeparator)) {
                  formattedNumber = formattedNumber.replace(new RegExp('\\' + decimalSeparator + '?0+$'), '');
                }
                
                return beforeNumber + formattedNumber + afterNumber;
              }
            }
          }
        }
      } catch (e) {
        // Silently handle Appstle widget errors
        console.log('Appstle money formatting error:', e);
      }
      
      const dollars = (cents / 100).toFixed(2);
      const displayPrice = dollars.endsWith('.00') ? dollars.slice(0, -3) : dollars.replace(/\.?0+$/, '');
      return '$' + displayPrice;
    },

    updatePerCupPrice: function(container) {
      const targetContainer = container || document;
      
      try {
        const perCupElements = targetContainer.querySelectorAll('.one-per_cup');
        
        perCupElements.forEach(perCupEl => {
          if (!perCupEl) return;
          
          let priceData = this.getCurrentVariantPrice(targetContainer);
          
          if (!priceData) {
            return;
          }
          
          if (priceData.source !== 'appstle') {
            return;
          }
          
          if (!priceData.price || isNaN(priceData.price) || priceData.price <= 0) {
            return;
          }
          
          const discount = this.getSubscriptionDiscount(targetContainer);
          
          let finalPrice = priceData.price;
          if (discount > 0 && !isNaN(discount)) {
            finalPrice = Math.round(priceData.price * (1 - discount / 100));
          }
          
          if (finalPrice <= 0) {
            return;
          }
          
          const coffeeCups = parseFloat(perCupEl.getAttribute('data-coffee-cups')) || 8.0;
          if (isNaN(coffeeCups) || coffeeCups <= 0) {
            return;
          }
          
          const perCupPrice = Math.ceil(finalPrice / coffeeCups);
          
          if (isNaN(perCupPrice) || perCupPrice <= 0) {
            return;
          }
          
          const currentPrice = perCupEl.getAttribute('data-price-per-cup');
          if (currentPrice === perCupPrice.toString()) {
            return;
          }
          
          const formattedPrice = this.formatMoney(perCupPrice, targetContainer);
          
          if (formattedPrice) {
            perCupEl.setAttribute('data-price-per-cup', perCupPrice);
            perCupEl.innerHTML = formattedPrice + '/cup';
          }
        });
      } catch (e) {
        // Silently handle errors during price update
        console.log('Update per cup price error:', e);
      }
    },

    waitForAppstlePrice: function(container, callback, maxAttempts) {
      const self = this;
      const targetContainer = container || document;
      maxAttempts = maxAttempts || 20;
      let attempts = 0;
      
      const checkPrice = function() {
        const priceData = self.getCurrentVariantPrice(targetContainer);
        
        if (priceData && priceData.source === 'appstle') {
          callback();
        } else if (attempts < maxAttempts) {
          attempts++;
          setTimeout(checkPrice, 200);
        }
      };
      
      checkPrice();
    },

    init: function(container) {
      const targetNode = container || document.body;
      const self = this;
      
      try {
        const config = { childList: true, subtree: true };
        
        const callback = function(mutationsList, observer) {
          try {
            const appstleWidget = targetNode.querySelector('.appstle_subscription_wrapper');
            if (appstleWidget) {
              observer.disconnect();
              
              // Add delay to ensure Appstle widget is fully initialized
              setTimeout(function() {
                self.waitForAppstlePrice(targetNode, function() {
                  try {
                    self.attachEventListeners(targetNode);
                    self.attachVariantChangeListener(targetNode);
                    self.updatePerCupPrice(targetNode);
                  } catch (e) {
                    console.log('Appstle initialization callback error:', e);
                  }
                });
              }, 300);
            }
          } catch (e) {
            console.log('Appstle observer callback error:', e);
          }
        };
        
        const observer = new MutationObserver(callback);
        observer.observe(targetNode, config);
        
        setTimeout(function() {
          observer.disconnect();
          self.waitForAppstlePrice(targetNode, function() {
            try {
              self.attachEventListeners(targetNode);
              self.attachVariantChangeListener(targetNode);
              self.updatePerCupPrice(targetNode);
            } catch (e) {
              console.log('Appstle timeout initialization error:', e);
            }
          });
        }, 10000);
      } catch (e) {
        console.log('SubscriptionPriceUpdater init error:', e);
      }
    },

    attachEventListeners: function(container) {
      const self = this;
      const targetContainer = container || document;
      
      try {
        const subscriptionRadios = targetContainer.querySelectorAll('input[name="selling_plan"]');
        subscriptionRadios.forEach(radio => {
          if (radio && !radio.dataset.perCupListenerAdded) {
            radio.dataset.perCupListenerAdded = 'true';
            radio.addEventListener('change', function() {
              try {
                self.debouncedUpdate(targetContainer, 150);
              } catch (e) {
                console.log('Subscription radio change error:', e);
              }
            });
          }
        });
        
        const subscriptionSelects = targetContainer.querySelectorAll('[id^="appstle_selling_plan"]');
        subscriptionSelects.forEach(select => {
          if (select && !select.dataset.perCupListenerAdded) {
            select.dataset.perCupListenerAdded = 'true';
            select.addEventListener('change', function() {
              try {
                self.debouncedUpdate(targetContainer, 150);
              } catch (e) {
                console.log('Subscription select change error:', e);
              }
            });
          }
        });

        const subscriptionWrappers = targetContainer.querySelectorAll('.appstle_subscription_wrapper_option');
        subscriptionWrappers.forEach(wrapper => {
          if (wrapper && !wrapper.dataset.perCupListenerAdded) {
            wrapper.dataset.perCupListenerAdded = 'true';
            wrapper.addEventListener('click', function() {
              try {
                self.debouncedUpdate(targetContainer, 150);
              } catch (e) {
                console.log('Subscription wrapper click error:', e);
              }
            });
          }
        });
      } catch (e) {
        console.log('Attach event listeners error:', e);
      }
    },

    reattachEventListeners: function(container) {
      const targetContainer = container || document;
      
      const subscriptionRadios = targetContainer.querySelectorAll('input[name="selling_plan"]');
      subscriptionRadios.forEach(radio => {
        delete radio.dataset.perCupListenerAdded;
      });
      
      const subscriptionSelects = targetContainer.querySelectorAll('[id^="appstle_selling_plan"]');
      subscriptionSelects.forEach(select => {
        delete select.dataset.perCupListenerAdded;
      });
      
      const subscriptionWrappers = targetContainer.querySelectorAll('.appstle_subscription_wrapper_option');
      subscriptionWrappers.forEach(wrapper => {
        delete wrapper.dataset.perCupListenerAdded;
      });
      
      this.attachEventListeners(targetContainer);
    },

    attachVariantChangeListener: function(container) {
      const self = this;
      const targetContainer = container || document;
      
      if (typeof PUB_SUB_EVENTS !== 'undefined' && typeof subscribe === 'function') {
        const productInfo = targetContainer.closest ? targetContainer.closest('product-info') : null;
        const sectionId = productInfo ? productInfo.dataset.section : null;
        
        if (!targetContainer.dataset.variantChangeListenerAdded) {
          targetContainer.dataset.variantChangeListenerAdded = 'true';
          
          subscribe(PUB_SUB_EVENTS.variantChange, function(event) {
            if (!sectionId || event.data.sectionId === sectionId || event.data.sectionId === 'quickadd-' + sectionId) {
              self.isUpdatingVariant = true;
              
              if (self.updateTimer) {
                clearTimeout(self.updateTimer);
              }
              
              const appstleWidget = targetContainer.querySelector('.appstle_subscription_wrapper');
              if (appstleWidget) {
                try {
                  const widgetObserver = new MutationObserver(function(mutations, obs) {
                    obs.disconnect();
                    
                    // Add delay to ensure Appstle data is ready
                    setTimeout(function() {
                      self.waitForAppstlePrice(targetContainer, function() {
                        try {
                          self.reattachEventListeners(targetContainer);
                          self.updatePerCupPrice(targetContainer);
                          self.isUpdatingVariant = false;
                        } catch (e) {
                          console.log('Appstle widget observer callback error:', e);
                          self.isUpdatingVariant = false;
                        }
                      }, 30);
                    }, 200);
                  });
                  
                  widgetObserver.observe(appstleWidget, { 
                    childList: true, 
                    subtree: true,
                    characterData: true
                  });
                  
                  setTimeout(function() {
                    widgetObserver.disconnect();
                    self.waitForAppstlePrice(targetContainer, function() {
                      try {
                        self.reattachEventListeners(targetContainer);
                        self.updatePerCupPrice(targetContainer);
                        self.isUpdatingVariant = false;
                      } catch (e) {
                        console.log('Appstle widget timeout error:', e);
                        self.isUpdatingVariant = false;
                      }
                    }, 30);
                  }, 2000);
                } catch (e) {
                  console.log('Appstle widget observer setup error:', e);
                  self.isUpdatingVariant = false;
                }
              } else {
                self.waitForAppstlePrice(targetContainer, function() {
                  try {
                    self.reattachEventListeners(targetContainer);
                    self.updatePerCupPrice(targetContainer);
                    self.isUpdatingVariant = false;
                  } catch (e) {
                    console.log('Appstle wait for price error:', e);
                    self.isUpdatingVariant = false;
                  }
                }, 30);
              }
            }
          });
        }
      }
    }
  };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function() {
      window.SubscriptionPriceUpdater.init();
    });
  } else {
    window.SubscriptionPriceUpdater.init();
  }
})();

